// mj-faq-page: loaded only where the section is used (sections/mj-faq-page.liquid)

// Highlights the category of the group currently in view, and keeps its chip visible on mobile.
class MjFaqPage extends HTMLElement {
  connectedCallback() {
    this.links = [...this.querySelectorAll('[data-mj-faq-link]')];
    if (!this.links.length) return;
    const groups = [...this.querySelectorAll('[data-mj-faq-group]')];
    this.observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (visible) this.setActive(visible.target.id);
      },
      { rootMargin: '-35% 0px -55% 0px' }
    );
    groups.forEach((group) => this.observer.observe(group));
    this.setActive(groups[0]?.id);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  setActive(id) {
    this.links.forEach((link) => {
      const active = link.dataset.mjFaqLink === id;
      link.setAttribute('aria-current', String(active));
      if (active) {
        const list = link.closest('.mj-faqp__nav-list');
        if (list && list.scrollWidth > list.clientWidth) {
          list.scrollTo({ left: link.offsetLeft - (list.clientWidth - link.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
    });
  }
}

if (!customElements.get('mj-faq-page')) customElements.define('mj-faq-page', MjFaqPage);
